import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'supplierStatusTagSeverity',
})
export class SupplierStatusTagSeverityPipe implements PipeTransform {
  transform(status: string): 'success' | 'secondary' | 'info' | 'warn' | 'danger' | 'contrast' {
    switch (status) {
      case 'Approved':
      case 'Active':
        return 'success';

      case 'Rejected':
      case 'Initial Stage Rejected':
      case 'Final Stage Rejected':
        return 'danger';

      default:
        return 'warn';
    }
  }
}
